import { AUTH_TOKEN, BACKEND_BASE_URL } from '../env';

export const CHANGE_NOTIFICATIONS_URL = '/api/v1/change_notifications';
export const CHANGE_NOTIFICATIONS_MARK_AS_SEEN_URL = '/api/v1/change_notifications/mark_as_seen';
export const getRemovePeriodsURL = (draftId: string) => `/api/v1/documents/periods/by_draft/${draftId}`;
export const getRemoveRelatedTasksURL = (draftId: string) => `/api/v1/documents/related_tasks/by_draft/${draftId}`;
export const getRelatedTasksURL = (documentId: string) => `/api/v1/documents/${documentId}/related_tasks`;
export const getDeletedDocumentsURL = () => `/api/v1/documents/deleted_documents`;
export const getResetTestCustomerURL = (customerId: string) => `/api/v1/customers/${customerId}/reset_test_customer`;
export const getRestoreFolderWithDocumentsURL = (documentId: string) =>
  `/api/v1/documents/${documentId}/restore_with_folder`;
export const getPostVeryfyMfaURL = () => `/api/v1/auth/mfa_verify`;

export async function get(resourcePath: string, queryParams: URLSearchParams): Promise<Response> {
  const authToken = JSON.parse(localStorage.getItem(AUTH_TOKEN) || '');
  const url = BACKEND_BASE_URL + resourcePath + '?' + queryParams;
  return await fetch(url, {
    method: 'GET',
    headers: new Headers({ Authorization: 'Bearer ' + authToken }),
    mode: 'cors',
  });
}
export async function put(resourcePath: string, body: Object): Promise<Response> {
  const authToken = JSON.parse(localStorage.getItem(AUTH_TOKEN) || '');
  const url = BACKEND_BASE_URL + resourcePath;
  return await fetch(url, {
    method: 'PUT',
    headers: new Headers({ Authorization: 'Bearer ' + authToken, 'Content-type': 'application/json; charset=UTF-8' }),
    body: JSON.stringify(body),
  });
}

export async function getWithoutBody(resourcePath: string): Promise<Response> {
  const authToken = JSON.parse(localStorage.getItem(AUTH_TOKEN) || '');
  const url = BACKEND_BASE_URL + resourcePath;
  return await fetch(url, {
    method: 'GET',
    headers: new Headers({ Authorization: 'Bearer ' + authToken }),
    mode: 'cors',
  });
}

export async function post(resourcePath: string, body: Object): Promise<any> {
  const authToken = JSON.parse(localStorage.getItem(AUTH_TOKEN) || '""');
  const url = BACKEND_BASE_URL + resourcePath;

  const response = await fetch(url, {
    method: 'POST',
    headers: new Headers({
      Authorization: 'Bearer ' + authToken,
      'Content-type': 'application/json; charset=UTF-8',
    }),
    body: JSON.stringify(body),
  });

  const text = await response.text();
  let json = null;
  try {
    json = text ? JSON.parse(text) : null;
  } catch (e) {
    console.error('Response was not valid JSON:', text);
  }

  return { ok: response.ok, status: response.status, body: json };
}

export async function remove(resourcePath: string): Promise<Response> {
  const authToken = JSON.parse(localStorage.getItem(AUTH_TOKEN) || '');
  const url = BACKEND_BASE_URL + resourcePath;

  return await fetch(url, {
    method: 'DELETE',
    headers: new Headers({ Authorization: 'Bearer ' + authToken, 'Content-type': 'application/json; charset=UTF-8' }),
  });
}
